"use strict";

exports.__esModule = true;
exports.convertToMillis = void 0;
exports.createDurationRangeList = createDurationRangeList;
var _timeDefinitions = require("../../timeDefinitions");
var secondsToMillis = function secondsToMillis(s) {
  return s * _timeDefinitions.SECOND_IN_MILLIS;
};
var minutesToMillis = _timeDefinitions.getMinutesMillis;
var hoursToMillis = _timeDefinitions.getHoursMillis;
var convertToMillis = exports.convertToMillis = function convertToMillis(val) {
  var unit = val.unit,
    from = val.from;
  switch (unit) {
    case "second":
      return secondsToMillis(from);
    case "minute":
      return minutesToMillis(from);
    case "hour":
      return hoursToMillis(from);
    default:
      return from;
  }
};

// TODO: change any to rangeListType
function createDurationRangeList(rangeList) {
  var durationRangeList = [];
  rangeList.forEach(function (range, index) {
    durationRangeList[index] = {
      from: convertToMillis(range)
    };
    if (index !== 0) {
      durationRangeList[index - 1] = {
        from: durationRangeList[index - 1].from,
        to: convertToMillis(range)
      };
    }
  });
  return durationRangeList;
}